import React, {FC} from "react";
import {Container, Typography} from "@material-ui/core";
import {isPast,} from "date-fns";
import {AuthContext} from "../../../auth/components/AuthProvider";
import {useAppDispatch, useAppSelector} from "../../../redux/redux.hook";
import {listWorkerOrders} from "../../orders/redux/orders.thunk";
import {selectAllOrders} from "../../orders/redux/orders.slice";
import {OrderPreviewCard} from "../../orders/sharedComponents/OrderPreviewCard";
import {FeOrder} from "../../orders/redux/types";
import {createSelector} from "@reduxjs/toolkit";
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";

const filterByUpcoming = (o: FeOrder) => !filterByTookPlace(o) && !filterByFinalized(o);
const filterByTookPlace = (o: FeOrder) => !filterByFinalized(o) && isPast(o.estimatedTo);
const filterByFinalized = (o: FeOrder) => Boolean(o.from && o.to);

type OrderStatusType = "upcoming" | "tookPlace" | "finalized";

const filterMap: { [key in OrderStatusType]: (o: FeOrder) => boolean } = {
    upcoming: filterByUpcoming,
    tookPlace: filterByTookPlace,
    finalized: filterByFinalized
}

const createMakeSelectByType = (type: OrderStatusType) =>
    createSelector(
        selectAllOrders,
        (allOrders) => allOrders.filter(o =>
            o.confirmed &&
            !o.cancellation &&
            filterMap[type](o)
        )
    );

export const WorkerScheduleScreen: FC = () => {
    const dispatch = useAppDispatch();
    const {userId} = React.useContext(AuthContext);

    const [selectMode, setSelectionMode] = React.useState<OrderStatusType>("upcoming");

    const handleChangeSelectionMode = (
        event: React.MouseEvent<HTMLElement>,
        newSelectionMode: OrderStatusType,
    ) => {
        setSelectionMode(newSelectionMode);
    };

    const filteredOrders = useAppSelector((state) => createMakeSelectByType(selectMode)(state));

    React.useEffect(() => {
        if (userId) {
            dispatch(listWorkerOrders({
                workerId: userId,
            }));
        }
    }, [dispatch, userId]);

    return (
        <Container style={{paddingTop: 16}}>
            <Typography color="primary" variant="h5" style={{marginBottom: 16}}>
                Aufträge
            </Typography>
            <ToggleButtonGroup
                color="primary"
                value={selectMode}
                exclusive
                onChange={handleChangeSelectionMode}
                style={{marginBottom: 16}}
            >
                <ToggleButton value="upcoming">Geplant</ToggleButton>
                <ToggleButton value="tookPlace">Stattgefunden</ToggleButton>
                <ToggleButton value="finalized">Beendet</ToggleButton>
            </ToggleButtonGroup>
            {filteredOrders.map(o =>
                <OrderPreviewCard order={o}/>
            )}
        </Container>
    )
}
